import { Box, Text } from '@bonanza-social/moonlight';
import { InviteStatusBottomSheetProps } from './InviteStatusBottomSheet.types';
import { useTranslation } from 'react-i18next';
import { memo, useMemo } from 'react';

function InviteStatusBottomSheet({
  playerExecutionCount,
  playerExecutionLimit,
}: InviteStatusBottomSheetProps) {
  const { t } = useTranslation('inviteFriends');
  const hasLimit = playerExecutionLimit !== undefined;

  const headlineText = useMemo(() => {
    return hasLimit
      ? t('unique_link_info', {
          invites: playerExecutionCount,
          left: playerExecutionLimit - playerExecutionCount,
        })
      : t('unique_link_info_claimed', {
          invites: playerExecutionCount,
        });
  }, [hasLimit, playerExecutionCount, playerExecutionLimit, t]);

  return (
    <Box gap="space-200">
      <Text variant="h5" color="darkSurfacePrimary">
        {headlineText}
      </Text>
      {hasLimit ? (
        <Text variant="body-m" color="darkSurfacePrimary">
          {t('invite_status_desc', { limit: playerExecutionLimit })}
        </Text>
      ) : (
        <Text
          variant="body-m"
          color="darkSurfacePrimary"
          locNS="inviteFriends"
          locKey="invite_status_desc_no_limit"
        />
      )}
    </Box>
  );
}

export default memo(InviteStatusBottomSheet);
